/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useCallback, useState } from 'react';
import styled from '@mui/styled-engine';
import get from 'lodash/get';
// import Button from 'antd/lib/button';
import { style } from '@/styles/globals';
import CloseIcon from '@mui/icons-material/Close';
import {
  TMinFareObj,
} from '@/slices/flightData/apis/flightDataApi';
import Image from '@/containers/SearchFlightTabVcms/Image';
import SearchFormInput from './SearchFormInput';
// import DateInput from '#/components/base/DateInput';
import { addAllHomePoints, adjustAllPassengers } from '@/slices/area/slices/searchFlightFormSlice';
import { useDispatch } from 'react-redux';
import { useAppSelector } from '@/utils/hook';
import DateInput from './SearchFormInput/DateInput';
import CalendarList from '../../components/CalendarList';
import {
  CircularProgress, Dialog, FormControlLabel, FormGroup, Grid, Stack, SwipeableDrawer, SwipeableDrawerProps, Typography,
} from '@mui/material';
import TransportationTabs from '../../components/TransportationTabs';
import IOSSwitch from '@/components/Vex/IosSwitch';
import {
  setChooseReturn, setDepartDate, setReturnDate, setShowCalendarVietNam,
} from '@/slices/calendar/calendarSlice';
import { uniqueId } from 'lodash';
import { TGenerateFlightCountRequest } from '@/utils/generateFlightRequest';
import { IPassengerSearchForm } from '@/slices/passenger/slices/type';
import { SeatClassType } from '../SearchFlightTab/ChooseSeatClass/type';
import { getAreaPointArr } from '@/utils';
import { monthYears } from '@/utils/monthYears';
import { pr } from '@/utils/pxToRem';
import { useLazyGetFlightStatistics2Query } from '@/slices/flightData/apis/flightDataApi';
import ChoosePassenger from './ChoosePassenger';
import ChooseSeatClass from './ChooseSeatClass';
import FindRouteButton from './FindRouteButton';
import type { TSelectedLocalDate } from '../SearchFlightTab';
import { TSetSelectedDate, TSetSelectedDateParams } from '@/components/CustomCalendar/type';
import {
  differenceInDays, format, formatDistance, getDay,
} from 'date-fns';
import { removeReturnFlight } from '@/slices/selectedFlight/slices/selectedFlightSlice';
import AddIcon from '@mui/icons-material/Add';
import vi from 'date-fns/locale/vi';
import { ILangObj } from '@/slices/goyoloSeo/sliceType';
import RedirectAlert from '@/components/RedirectAlert';
import { useBoolean } from '@/utils/hooks';

const lineRouteIcon = 'https://storage.googleapis.com/fe-production/svgIcon/line-route.svg';
const pickupIcon = 'https://storage.googleapis.com/goyolo-uat/images/SeoVexImprove/pickup_vex_blue_24dp.svg';
const dropoffIcon = 'https://storage.googleapis.com/goyolo-uat/images/SeoVexImprove/pickup_negative_24dp.svg';
const switchIcon = 'https://storage.googleapis.com/fe-production/svgIcon/import_export_dark_24dp.svg';

export enum LocationSearchType {
  FROM = 'from',
  TO = 'to',
}

const StyledDialog = styled(Dialog)`
  .MuiButtonBase-root.MuiTab-root.Mui-selected {
    color: black;
  }
  .MuiTabs-indicator {
    background: black;
  }
  .MuiPaper-root > .MuiTabs-root {
    height: 5em;
  }
`;

const StyledGridContainer = styled('div')`
  display: block;
  margin-top: 12px;
  margin-bottom: 10px;
`;

export const Caption = styled('p')`
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0.1px;
  margin-bottom: 0;
  margin-top: 0;
  word-break: break-word;
`;

export const Headline = styled('p')`
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: -0.25px;
  margin-bottom: 0;
  margin-top: 0;
  word-break: break-word;
`;

export const ButtonLabel = styled('p')`
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: 0;
  margin-bottom: 0;
  word-break: break-word;
  margin-top: 0px;
`;

const Container = styled('div')`
  &.search-widget-section {
    // padding: 16px 20px;
    background: #2474E5;
    
    .from-name,
    .to-name,
    .bus-name {
      display: -webkit-box;
      overflow: hidden;
      text-overflow: ellipsis;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
    }

    .search-widget {
      display: flex;
      flex-direction: column;
      width: 100%;
      border-radius: 8px;
      box-shadow: 0px 4px 32px -4px rgba(0, 0, 0, 0.16);
      background: ${style.neutral.white};

      .icon-container {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding: 20px 16px;
      }

      .from-to-section {
        display: flex;
        flex-direction: row;
      }

      .from-select,
      .to-select {
        display: flex;
        flex-direction: column;
        height: 64px;
        justify-content: center;
      }

      .from-select-border {
        border-bottom: 0.5px solid ${style.neutral.lightBorder};
      }

      .from-to-select-container {
        flex: 1;
        display: flex;
        flex-direction: column;
        position: relative;
        padding-right: 56px;

        .switch-route-icon {
          position: absolute;
          top: 48px;
          right: 16px;
          width: 32px;
          height: 32px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 100%;
        }
      }

      .divider {
        margin-left: 16px;
        margin-top: 6px;
        margin-bottom: 10px;
        border-bottom: 0.5px solid ${style.neutral.lightBorder};
      }
    }

    .search-btn {
      width: 100%;
      margin-top: 16px;
      height: auto;
      padding: 12px 16px;
      border-radius: 8px;

      p {
        display: inline-block;
      }
    }
  }
`;

const DateInputSt = styled('div')`
`;

const StickyLowerControlVex = ({
  selectedDate,
  selectDateClick,
  toggleReturn,
  isReturn,
  lang,
}: {
  selectedDate: TSelectedLocalDate;
  onDone: () => void;
  chooseReturn: boolean;
  onChooseReturn: (newStatus: boolean) => void;
  setSelectedDate: TSetSelectedDate;
  selectDateClick?: any;
  toggleReturn?: any;
  isReturn: boolean;
  lang?: ILangObj;
}) => {
  // const dispatch = useDispatch();

  const getDayText = (inputDate: Date) => {
    const day = getDay(inputDate);
    if (lang?.lang === 'en') {
      return format(inputDate, 'EE, MMM dd, yyyy');
    }
    return `${day > 0 ? `T${day + 1}` : 'CN'} - ${format(
      inputDate,
      'dd/MM/yyyy',
    )}`;
  };
  let interLinkText = '';
  const departDate = selectedDate.depart;
  const returnDate = selectedDate.return ? selectedDate.return : null;
  if (departDate && returnDate) {
    const diffDates = differenceInDays(returnDate, departDate);
    if (diffDates === 0) {
      interLinkText = 'cùng ngày';
    } else {
      interLinkText = `${diffDates + 1} ngày`;
    }
  }
  return (
    // <StickyLowerControlContainer>
    <Stack
      spacing="1.5em"
      sx={{
        width: '100%',
      }}
      alignItems="center"
    >
      <Grid
        container
        width="100%"
      // direction="row"
      // alignItems="flex-start"
      // justifyContent="space-between"
      // spacing={returnDate ? '50px' : pr`16px`}
      >
        <Grid
          item
          xs={lang?.lang === 'en' ? 4.5 : 5}
        >
          {' '}
          <DateInputSt
            onClick={() => selectDateClick({ isReturn: false })}
          >
            <Stack sx={{ width: '100%' }}>
              <Caption style={{
                color: '#fff',
              }}
              >
                {lang?.SearchBar?.flightsTab?.departureDate || 'Ngày đi'}
              </Caption>
              <Headline style={{
                color: '#fff',
              }}
              >
                {getDayText(departDate)}
              </Headline>
            </Stack>
          </DateInputSt>

        </Grid>
        <Grid
          item
          xs={lang?.lang === 'en' ? 3 : 2}
        >
          <Stack
            direction="column"
            justifyContent="space-between"
            alignItems="center"
            sx={{
              paddingRight: '16px',
            }}
          >
            <Caption
              style={{
                color: '#fff',
              }}
            >
              {lang?.SearchBar?.flightsTab?.roundTrip || 'Khứ hồi'}
            </Caption>
            <IOSSwitch
              onChange={(valueInput: any) => toggleReturn(valueInput?.target?.checked)}
              checked={isReturn}
            />

          </Stack>
        </Grid>
        <Grid
          item
          xs={lang?.lang === 'en' ? 4.5 : 5}

        >
          <Stack>
            {isReturn
              && (
                <DateInputSt
                  onClick={() => selectDateClick({ isReturn: true })}
                >
                  {returnDate ? (
                    <Stack sx={{ width: '100%' }}>
                      <Stack
                        sx={{ width: '100%' }}
                        justifyContent="flex-end"
                      >
                        <Caption style={{
                          color: '#fff',
                          textAlign: 'right',
                        }}
                        >
                          {lang?.SearchBar?.flightsTab?.returnDate || 'Ngày về'}
                        </Caption>
                        <Headline style={{
                          color: '#fff',
                          textAlign: 'right',
                        }}
                        >
                          {getDayText(returnDate)}
                        </Headline>
                      </Stack>
                    </Stack>
                  ) : (
                    <Stack
                      justifyContent="flex-end"
                      sx={{ width: '100%' }}
                    >
                      <Headline style={{
                        color: '#fff',
                        textAlign: 'right',
                      }}
                      >
                        {lang?.SearchBar?.flightsTab?.returnDate || 'Ngày về'}
                      </Headline>
                    </Stack>

                  )}

                </DateInputSt>
              )}
          </Stack>
        </Grid>

      </Grid>
    </Stack>
  );
};

const BottomDrawer = ({ children, ...props }: SwipeableDrawerProps) => (
  <SwipeableDrawer
    {...props}
    anchor="bottom"
    PaperProps={{
      ...props.PaperProps,
      style: {
        ...props.PaperProps?.style,
        width: '100%',
        margin: 0,
        position: 'absolute',
        left: 0,
        bottom: 0,
        background: style.primary.blue,
        boxShadow:
          '0px 0px 0px 1px rgba(28, 59, 84, 0.05), 0px -2px 6px -2px rgba(28, 59, 84, 0.04), 0px -8px 12px -3px rgba(28, 59, 84, 0.08)',
        borderRadius: '16px 16px 0px 0px',
      },
    }}
  >
    {children}
  </SwipeableDrawer>
);

const SearchWidget = ({
  isTrain,
  className = '',
  t,
  payload,
  onSelectFromInput,
  onSelectToInput,
  onSwap,
  onOpenCalendar,
  onSearchClick,
  // isLoading,
  searchText,
  isCallFromHomepage,
  filterAirline,
  lang,
  startPointSeo,
  toPointSeo,
  isFirstTime,
  switchUpdateSecondTime,
  statePassengerSeo,
  stateSeatClassSeo,
}: {
  className?: any,
  t?: any,
  payload?: any,
  onSelectFromInput?: any,
  onSelectToInput?: any,
  onSwap?: any,
  onOpenCalendar?: any,
  onSearchClick?: any,
  // isLoading,
  searchText?: any,
  isCallFromHomepage?: any,
  filterAirline?: any,
  lang?: ILangObj,
  startPointSeo?: any,
  toPointSeo?: any,
  isFirstTime: boolean,
  switchUpdateSecondTime: any,
  statePassengerSeo: any,
  stateSeatClassSeo: any,
  isTrain?: boolean,
}) => {
  console.log('🚀 ~ isTrain:', isTrain);
  const dispatch = useDispatch();
  const [open, setOpen] = useBoolean(false);
  const [openDialog, setOpenDialog] = React.useState(false);
  const {
    startPointHome,
    toPointHome,
  } = useAppSelector((state) => state.searchFlightForm);
  let {
    seatClass: stateSeatClass,
    passenger: statePassenger,
  } = useAppSelector((state) => state.searchFlightForm);

  const chooseReturn = useAppSelector((state) => state.calendar.chooseReturn);
  const setReturn = (newStatus: boolean) => dispatch(setChooseReturn({ chooseReturn: newStatus }));

  const startPoint = isFirstTime ? startPointSeo : startPointHome;
  const toPoint = isFirstTime ? toPointSeo : toPointHome;
  stateSeatClass = isFirstTime ? stateSeatClass : statePassengerSeo;
  statePassenger = isFirstTime ? statePassenger : stateSeatClassSeo;
  const [isReturn, setIsReturn] = useState(false);
  const isShowCalendarVietNam = useAppSelector(
    (state) => state.calendar.showCalendarVietNam,
  );
  const stateSelectedDate = useAppSelector(
    (state) => state.calendar.selectedDate,
  );
  const [selectedDepartDate, setSelectedDepartDate] = useState(
    stateSelectedDate && stateSelectedDate.depart ? new Date(stateSelectedDate.depart) : new Date(),
  );
  const [selectedReturnDate, setSelectedReturnDate] = useState(
    stateSelectedDate && stateSelectedDate.return ? new Date(stateSelectedDate.return) : null,
  );
  const selectedDate = isFirstTime ? {
    depart: new Date(),
    return: null,
  } : {
    depart: selectedDepartDate,
    return: selectedReturnDate,
  };

  const [passenger, adjustPassengerState] = useState<IPassengerSearchForm>(statePassenger);
  const [seatClass, adjustSeatClass] = useState<SeatClassType>(stateSeatClass);
  const [getMinFare, { isLoading, data }] = useLazyGetFlightStatistics2Query();

  const flightRequest: TGenerateFlightCountRequest = {
    from: startPoint ? getAreaPointArr(startPoint) : [],
    to: toPoint ? getAreaPointArr(toPoint) : [],
    month_years: monthYears(),
    flight_class: seatClass,
    quantity: passenger ? (passenger.adt + passenger.chd) : 0,
    child_infant_count: passenger ? (passenger.chd + passenger.inf) : 0,
    infant_count: passenger ? passenger.inf : 0,
    // disable_update_filter: 1,
  };

  const flightRequestReturn: TGenerateFlightCountRequest = {
    from: toPoint ? getAreaPointArr(toPoint) : [],
    to: startPoint ? getAreaPointArr(startPoint) : [],
    month_years: monthYears(),
    flight_class: seatClass,
    quantity: passenger ? (passenger.adt + passenger.chd) : 0,
    child_infant_count: passenger ? (passenger.chd + passenger.inf) : 0,
    infant_count: passenger ? passenger.inf : 0,
    // disable_update_filter: 1,
  };

  const setSelectedDate = (params: TSetSelectedDateParams) => {
    if (params && params.depart !== undefined && params.depart !== selectedDepartDate) {
      if (isCallFromHomepage) {
        dispatch(setDepartDate({ depart: params.depart.toISOString() }));
      }
      setSelectedDepartDate(params.depart);
    }
    if (params.return && params.return !== selectedReturnDate && openDialog) {
      setOpenDialog(false);
    }
    if (
      params.return === null
      || (params.return !== undefined && params.return !== selectedReturnDate)
    ) {
      if (isCallFromHomepage) {
        dispatch(
          setReturnDate({ return: params?.return?.toISOString() || null }),
        );
      }

      setSelectedReturnDate(params.return);
    }
  };

  const renderDay = (dayArr = ['T2', 'T3', 'T4', 'T5', 'T6', 'T7', 'CN']) => {
    const DayComponent = dayArr.map((day) => {
      const isWeekend = /T7|CN/i.test(day);
      return (
        <Typography
          variant="subtitle2"
          key={uniqueId()}
          style={{ color: style.primary.blueLight }}
        >
          {day}
        </Typography>
      );
    });
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-around',
        }}
      >
        {DayComponent}
      </div>
    );
  };
  const selectDateClick = ({ chooseReturnTrip = false }: { chooseReturnTrip?: boolean }) => {
    if (startPoint && toPoint) {
      if (chooseReturnTrip) {
        getMinFare(flightRequestReturn);
      } else {
        getMinFare(flightRequest);
      }
    }
  };

  const handleAdjustPassenger = useCallback(
    (tempPass: IPassengerSearchForm) => {
      if (isCallFromHomepage) {
        dispatch(adjustAllPassengers(tempPass));
      }
      adjustPassengerState(tempPass);
    },
    [],
  );

  const dayPriceObj = {} as TMinFareObj;
  data?.forEach((group) => {
    Object.keys(group?.grouped_by_date).forEach((groupedDate) => {
      dayPriceObj[groupedDate] = group?.grouped_by_date[groupedDate].min_fare;
    });
  });

  const openCalendar = (returnCalendar: boolean) => {
    setOpenDialog(true);
    if (startPoint && toPoint) {
      if (returnCalendar) {
        getMinFare(flightRequestReturn);
      } else {
        getMinFare(flightRequest);
      }
    }
  };

  const onSelectDateClickHandler = ({ chooseReturnTrip = false }: { chooseReturnTrip: boolean }) => {
    if (selectDateClick) {
      selectDateClick({ chooseReturnTrip });
    }
  };
  const handleRemoveReturnFlight = () => dispatch(removeReturnFlight());

  const onSearchButtonClick = () => {
    onSearchClick();
  };

  return (
    <Container className={`search-widget-section ${className}`}>
      <div className="search-widget bg--white">
        <div className="from-to-section">
          <div className="icon-container">
            <Image
              imageSrc={pickupIcon}
              alt="pickup-icon"
              className="pickup-icon"
              imageProps={{
                width: 24,
                height: 24,
              }}
            />

            <Image
              imageSrc={lineRouteIcon}
              alt="line-route-icon"
              className="line-route-icon"
              imageProps={{
                width: 24,
                height: 54,
              }}
            />

            <Image
              imageSrc={dropoffIcon}
              alt="dropoff-icon"
              className="dropoff-icon"
              imageProps={{
                width: 24,
                height: 24,
              }}
            />
          </div>

          <div className="from-to-select-container">
            <div
              className="search-widget-home from-select from-select-border"
              id="from-select"
              onClick={onSelectFromInput}
              style={{
                minHeight: '80px',
              }}
            >
              <SearchFormInput
                isTrain={isTrain}
                type={LocationSearchType.FROM}
                lang={lang}
                point={startPoint}
                isGetFromSeo={isFirstTime}
                onOpenSearchDialog={switchUpdateSecondTime}
              />
            </div>

            <div
              className="switch-route-icon bg--lightest-bg"
              onClick={() => {
                dispatch(
                  addAllHomePoints([
                    {
                      data: startPoint,
                      type: 'to',
                    },
                    {
                      data: toPoint,
                      type: 'from',
                    },
                  ]),
                );
              }}
            >
              <Image
                imageSrc={switchIcon}
                alt="switch-icon"
                className="switch-icon"
                imageProps={{
                  width: 24,
                  height: 24,
                }}
              />
            </div>

            <div
              className="search-widget-home to-select"
              id="to-select"
              onClick={onSelectToInput}
              style={{
                minHeight: '80px',
              }}
            >
              <SearchFormInput
                isTrain={isTrain}
                type={LocationSearchType.TO}
                lang={lang}
                point={toPoint}
                isGetFromSeo={isFirstTime}
                onOpenSearchDialog={switchUpdateSecondTime}
              />
            </div>
          </div>
        </div>

        <div className="divider" />

        <DateInput
          isTrain={isTrain}
          openCalendar={() => openCalendar(false)}
          label={lang?.SearchBar?.flightsTab?.departureDate || 'Ngày đi'}
          value={selectedDate.depart}
          dateFormat="EE, dd/MM/yyyy"
          onOpenCalendar={onOpenCalendar}
          className="departure-date-section"
          chooseReturn={isReturn}
          toggleReturn={(value: boolean) => {
            dispatch(setChooseReturn({ chooseReturn: value }));
            setIsReturn(value);
          }}
          lang={lang}
          switchUpdateSecondTime={switchUpdateSecondTime}
        />
        {isReturn && (<div className="divider" />)}
        {isReturn && (
          <DateInput
            isTrain={isTrain}
            lang={lang}
            openCalendar={() => openCalendar(true)}
            isReturn
            label={lang?.SearchBar?.flightsTab?.chooseReturnDate || 'Ngày về'}
            value={selectedDate.return}
            dateFormat="EE, dd/MM/yyyy"
            onOpenCalendar={onOpenCalendar}
            className="departure-date-section"
            switchUpdateSecondTime={switchUpdateSecondTime}
          />
        )}
        <div className="divider" />
        {!isTrain && (
          <Grid
            container
            spacing={1}
          >
            <Grid
              item
              xs={6}
              sx={{
                paddingTop: '0px !important',
              }}
            >
              <ChoosePassenger
                passenger={passenger}
                adjustPassenger={handleAdjustPassenger}
                lang={lang}
                switchUpdateSecondTime={switchUpdateSecondTime}
              />
            </Grid>

            <Grid
              item
              xs={6}
              sx={{
                paddingTop: '0px !important',
              }}
            >
              <ChooseSeatClass
                lang={lang}
                seatClass={seatClass}
                adjustSeatClass={adjustSeatClass}
                switchUpdateSecondTime={switchUpdateSecondTime}
              />
            </Grid>

          </Grid>

        )}

      </div>

      <FindRouteButton
        lang={lang}
        filterAirline={filterAirline}
        onSearchClick={onSearchButtonClick}
        tmpStartPoint={startPoint}
        tmpToPoint={toPoint}
        tmpSelectedDate={selectedDate}
        tmpPassenger={passenger}
        tmpSeatClass={seatClass}
        isShowCalendarVietNam={isShowCalendarVietNam}
      />

      {/* <StyledDialog
        fullScreen
        open={openDialog}
        onClose={() => setOpenDialog(false)}
      >
        <Stack
          sx={{
            zIndex: 10,
            boxShadow: '0px 4px 12px rgb(0 0 0 / 4%)',
          }}
        >
          <TransportationTabs
            title="Chọn ngày"
            onBackClick={() => setOpenDialog(false)}
          />
          <StyledGridContainer>{renderDay()}</StyledGridContainer>
          <FormGroup
            style={{
              display: 'flex',
              textAlign: 'end',
              marginBottom: pr`16px`,
            }}
          >
            <FormControlLabel
              style={{
                justifyContent: 'flex-end',
                marginLeft: '10px',
              }}
              componentsProps={{
                typography: {
                  ...style.text.content.regular,
                  color: style.color.black2,
                },
              }}
              control={(
                <IOSSwitch
                  size="small"
                  color="secondary"
                  defaultChecked={isShowCalendarVietNam}
                />
              )}
              label={(
                <Typography
                  variant="body2"
                  sx={{ marginLeft: '8px' }}
                >
                  Lịch âm
                </Typography>
              )}
              defaultChecked={isShowCalendarVietNam}
              onChange={(value: any) => dispatch(
                setShowCalendarVietNam({ value: value?.target?.checked }),
              )}
            />
          </FormGroup>
        </Stack>
        {isLoading ? (
          <div
            style={{
              width: '100%',
              flex: 1,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <CircularProgress color="inherit" />
          </div>
        ) : (
          <CalendarList
            selectDateClick={selectDateClick}
            setOpenDialog={setOpenDialog}
            dayPriceObj={dayPriceObj}
            selectedDate={selectedDate}
            setSelectedDate={setSelectedDate}
          />
        )}
      </StyledDialog> */}
      <BottomDrawer
        onOpen={() => { }}
        open={openDialog}
        onClose={() => setOpenDialog(false)}
      >
        <Stack
          alignItems="center"
          justifyContent="center"
          sx={{
            marginTop: pr`12px`,
          }}
        >
          <span style={{
            width: '40px',
            height: '3px',
            background: '#E0E0E0',
            borderRadius: '8px',
          }}
          />
          <span style={{
            width: '40px',
            height: '3px',
            background: '#E0E0E0',
            borderRadius: '8px',
            marginTop: pr`2px`,
          }}
          />
        </Stack>
        <Stack
          spacing="1.75em"
          sx={{ p: '1.5em 0' }}
        >
          <Stack>
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              sx={{ p: '0 1em' }}
            >
              <Typography sx={{
                fontWeight: 700,
                fontSize: '20px',
                lineHeight: '28px',
                color: '#fff',
              }}
              >
                {lang?.SearchBar?.flightsTab?.chooseDate || 'Chọn ngày'}
              </Typography>
              <Typography sx={{
                fontWeight: 700,
                fontSize: '14px',
                lineHeight: '20px',
                textDecorationLine: 'underline',
                color: '#fff',
              }}
              >
                {lang?.global?.close || 'Đóng'}
              </Typography>
            </Stack>
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              sx={{ p: '0 1em' }}
            >
              <StickyLowerControlVex
                selectDateClick={onSelectDateClickHandler}
                selectedDate={selectedDate}
                setSelectedDate={setSelectedDate}
                chooseReturn={chooseReturn}
                onChooseReturn={setReturn}
                onDone={() => setOpenDialog(false)}
                toggleReturn={(value: boolean) => {
                  dispatch(setChooseReturn({ chooseReturn: value }));
                  setIsReturn(value);
                }}
                isReturn={isReturn}
                lang={lang}
              />
            </Stack>
            <StyledGridContainer>{renderDay(lang?.global?.dayOfWeek)}</StyledGridContainer>
            <div
              style={{
                background: '#fff',
                fontWeight: 700,
                fontSize: '14px',
                lineHeight: '20px',
                textAlign: 'right',
                padding: '16px 1em',
                color: '#2474E5',
                textDecoration: 'underline',
              }}
              onClick={() => dispatch(
                setShowCalendarVietNam({ value: !isShowCalendarVietNam }),
              )}
            >
              {isShowCalendarVietNam ? (lang?.global?.hideLunarCalendar || 'ẨN Lịch âm') : (lang?.global?.displayLunarCalendar || 'Hiển thị lịch âm')}
            </div>
            <div style={{
              background: '#fff',
              margin: '0 !important',
              maxHeight: '400px',
            }}
            >
              {isLoading ? (
                <div
                  style={{
                    width: '100%',
                    flex: 1,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    background: '#fff',
                    marginTop: '0px !important',
                  }}
                >
                  <CircularProgress color="inherit" />
                </div>
              ) : (

                <CalendarList
                  seo
                  selectDateClick={selectDateClick}
                  setOpenDialog={setOpenDialog}
                  dayPriceObj={dayPriceObj}
                  selectedDate={selectedDate}
                  setSelectedDate={setSelectedDate}
                  lang={lang}
                />

              )}

            </div>
          </Stack>
        </Stack>
      </BottomDrawer>
      <RedirectAlert
        open={open}
        setOpen={setOpen}
        onConfirm={onSearchButtonClick}
        params={{}}
      />
    </Container>
  );
};

export default SearchWidget;
